<template>
  <div class="mt-component-form print-container">
    <vs-row  v-if="isShowTitle">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> {{title}}
        </h5>
      </vs-col>
    </vs-row>

    <div class="pc" :class="onlyPc ? ['block'] : ['hidden', 'xl:block']">
      <!-- 테이블 헤더 -->
      <div class="mt-4 grid row-header" :style="`grid-template-columns: 1fr ${headerWidthYes} ${headerWidthNo} ${headerWidthNa} ${isNote ? headerWidthNote : ''}`">
        <div class="row-header__item">{{getHeaderTitle}}</div>
        <div class="row-header__item">{{getHeaderYes}}</div>
        <div class="row-header__item">{{getHeaderNo}}</div>
        <div class="row-header__item" style="white-space: nowrap;">{{getHeaderNa}}</div>
        <div v-if="isNote" class="row-header__item">{{getHeaderNote}}</div>
      </div>


      <!-- 테이블 본문 영역 -->
      <div class="grid row-content__body-item"
           v-for="(rows, indexRows) in list" :key="indexRows"
           :style="{ gridTemplateColumns: `1fr ${headerWidthYes} ${headerWidthNo} ${headerWidthNa} ${isNote ? headerWidthNote : ''}`,
           borderBottom: (indexRows === list.length - 1 ? '1px solid #cdcdcd' : '')}"
      >
        <!-- title 속성이 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
        <div v-if="rows.title && rows.title !== ''
              && (indexRows === 0 || list[indexRows].title !== list[indexRows - 1].title)"
             class="col-span-12 item-title" :style="`background-color: ${rows.titleColor}`">
          <b>{{rows.title}}</b>
        </div>

        <!-- 항목 구분-->
        <div v-if="rows.group" class="grid " :style="'grid-template-columns: 100px 1fr'" :set="(groupData = rows.group)">
          <div v-if="indexRows==0 || (list[indexRows - 1].group != groupData)" class="border-right" style="display: flex;justify-content: center;align-items: center;background-color: #F9F9F9; white-space:pre-line" v-text="rows.group"></div>
          <div v-else></div>
          <div class="item-content">
            <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
            <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
          </div>
        </div>
        <!-- 항목 이름  -->
        <div v-else class="item-content">
          <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
          <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
        </div>

        <!-- YES -->
        <div class="item-box">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="rows.is_checked === 'Yes'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            style="padding-left: 5px;"
            :disabled="isReadonly"
            :checked="rows.is_checked === 'Yes'"
            @change="checkForm($event, rows.id, 'Yes')"
          ></vs-checkbox>
        </div>

        <!-- No -->
        <div class="item-box">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="rows.is_checked === 'No'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            :disabled="isReadonly"
            :checked="rows.is_checked === 'No'"
            style="margin-right: 0;padding-left: 5px;"
            @change="checkForm($event, rows.id, 'No')"
          ></vs-checkbox>
        </div>

        <!-- N/A -->
        <div class="item-box">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="rows.is_checked === 'N/A'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            style="padding-left: 5px;"
            :disabled="isReadonly"
            :checked="rows.is_checked === 'N/A'"
            @change="checkForm($event, rows.id, 'N/A')"
          ></vs-checkbox>
        </div>

        <!-- 비고 -->
        <div v-if="isNote" class="item-note border-right">
          <span v-if="isPrint" class="print-input"> {{rows.note}} </span>
          <ml-input v-else class="w-full flex-1" v-model="rows.note" @change="updateRowNote($event, rows.id, rows.note)"  :readonly="isReadonly"/>
        </div>
      </div>

      <div v-if="isBottomNote" class="flex items-center mt-4">
        <div class="label-text mr-4">{{ bottomNoteTitle }}</div>
        <p v-if="isPrint" class="w-full flex-1">{{ bottomNote }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          :readonly="isReadonly"
          v-model="bottomNote"
          @change="updateBottomNote()"
        />
      </div>

      <!-- footer 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
      <div v-if="footer && footer !== ''" class="row-header__item justify-start">
        <b class="ml-2">{{footer}}</b>
      </div>
    </div>

    <!-- Mobile -->
    <div class="mobile xl:hidden mt-4" :class="onlyPc ? ['hidden'] : ['block', 'xl:hidden']">
      <ul>
        <li v-for="(item, item_i) in list" :key="item_i">
          <p v-if="!!item.title" style="font-weight: 500; font-size: 16px; line-height: 23px" class="mb-3" v-html="item.title"></p>
          <fragment>
            <p v-html="item.label"></p>

            <!--체크박스-->
            <div class="btn-container">
              <button type="button" :class="[item.is_checked === 'Yes' && 'active']" @click="item.is_checked = 'Yes'">{{ getHeaderYes }}</button>
              <button type="button" :class="[item.is_checked === 'No' && 'active']" @click="item.is_checked = 'No'">{{ getHeaderNo }}</button>
              <button type="button" :class="[item.is_checked === 'N/A' && 'active']" @click="item.is_checked = 'N/A'">{{ getHeaderNa }}</button>
            </div>

            <!--비고-->
            <ml-input class="w-full mt-3" v-model="item.note" placeholder="비고" :readonly="isReadonly" />
          </fragment>
        </li>
      </ul>
    </div>

  </div>


</template>

<script>
import config from "/public/config";
import {groupData} from "echarts/lib/util/model";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
export default {
  name: 'TableInspect',
  components: {PrintCheckbox},
  props: {
    isPrint: Boolean,
    isReadonly: Boolean,
    onlyPc: Boolean,
    /**
     * 테이블 상단에 동그라미(●) 제목을 표시할지 여부
     */
    isShowTitle: Boolean,
    /**
     * 가장 오른쪽 열에 "비고" 칸을 표시할지 여부
     * 은평 branch 에서는 "비고" 칸이 기본으로 노출된다
     */
    isNote: {
      type: Boolean,
      default: true,
    },
    title: String,
    list: Array,
    tableHeaderTitle: String,
    tableHeaderYes: String,
    tableHeaderNo: String,
    tableHeaderNa: String,
    tableHeaderNote: String,
    headerWidthYes: {
      type: String,
      default: '100px',
    },
    headerWidthNo: {
      type: String,
      default: '100px',
    },
    headerWidthNa: {
      type: String,
      default: '100px',
    },
    headerWidthNote: {
      type: String,
      default: '388px',
    },
    footer: String,
    isNotDotInLabel: Boolean,
    isBottomNote: {
      type: Boolean,
      default: false,
    },
    bottomNoteTitle : {
      type: String,
      default: '기타의견'
    },
    initBottomNote: {
      type: String,
      default: '',
    },
    tableHeaderCheck: {
      type: Array,
      default: () => [
        { text: "양호", width: "82" },
        { text: "미흡", width: "82" },
        { text: "해당없음", width: "82" },
      ],
    },
  },
  computed: {
    getHeaderTitle () {
      if (this.tableHeaderTitle) return this.tableHeaderTitle
      else return '점검내용'
    },
    getHeaderYes () {
      if (this.tableHeaderYes) return this.tableHeaderYes
      else {
        return '양호'
      }
    },
    getHeaderNo () {
      if (this.tableHeaderNo) return this.tableHeaderNo
      else {
        return '미흡'
      }
    },
    getHeaderNa () {
      if (this.tableHeaderNa) return this.tableHeaderNa
      else {
        return '해당없음'
      }
    },
    getHeaderNote () {
      if (this.tableHeaderNote) return this.tableHeaderNote
      else return '비고(보완계획)'
    }
  },
  emits: ['update-list-check', 'update-note', 'update-bottom-note'],
  methods: {
    groupData,
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows - 1, text)
      } else {
        this.$emit('update-list-check', indexRows - 1, '')
      }
    },

    updateRowNote (value, indexRows, text) {
      this.$emit('update-note', indexRows - 1, text)
    },

    updateBottomNote() {
      this.$emit('update-bottom-note', this.bottomNote);
    },
    customTypeInput(index, key, data) {
      this.$set(this.list[index], key, data);
    },
  },
  data () {
    return {
      hostname: config.HOST_NAME,
      bottomNote: this.initBottomNote,
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  //border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: $border;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  border-left: $border;

  .item-title {
    padding: 10px;
    border-right: $border;
    border-bottom: $border;
  }

  .item-content {
    padding: 10px;
    align-self: center;
    color: #3c3c3c;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }

    .row-title {
      font-weight: 500;
      display: inline-flex;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }

    .row-title-nodot {
      font-weight: 500;
      display: inline-flex;
    }
  }
  .item-box {
    border-left: $border;
    //border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-box:last-child {
    border-right: $border;
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }

  .item-note {
    padding: 5px;
    border-left: $border;
    height: 100%;
    display: inline-flex;
    align-items: center;
  }
}

.row-content__body-item:last-child {
  border-bottom: $border;
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*체크박스 중앙 정렬을 위함.. scope style 내에서는 적용이 안되서 외부로 뺐음*/
.row-content__body-item .item-box .vs-checkbox {
  margin-right: 0;
}

.mobile {
  ul {
    li {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      border: 1px solid #cdcdcd;
      padding: 15px;

      /*&:first-child {
        text-align: center;
        background: #f9f9f9;
      }*/
      &:nth-child(n + 2) {
        border-top: 0;
      }

      .btn-container {
        display: flex;
        align-items: center;
        border: 1px solid #cdcdcd;
        border-radius: 8px;
        overflow: hidden;
        margin-top: 20px;

        button {
          flex: 1;
          font-family: "Noto Sans KR";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #2c2c2c;
          background: none;
          border: 0;
          border-right: 1px solid #cdcdcd;
          outline: 0;
          padding: 11px 0;
          &:last-child {
            border-right: 0;
          }

          &.active {
            color: white;
            background: #200c63;
          }
        }
      }
    }
  }
}
</style>
